import { useWindowVirtualizer } from '@tanstack/react-virtual'
import React from 'react'

import { getMeasureElement } from './utils'

export type WindowVirtualizerType = ReturnType<typeof useWindowVirtualizer>

interface WindowVirtualizerProps {
  children: (virtualizer: WindowVirtualizerType) => React.ReactNode
  estimatedRowHeight: number
  rowsLength: number
  scrollMargin?: number
}

export const WindowVirtualizer = ({
  children,
  estimatedRowHeight,
  rowsLength,
  scrollMargin,
}: WindowVirtualizerProps) => {
  const rowVirtualizer = useWindowVirtualizer({
    count: rowsLength,
    estimateSize: () => estimatedRowHeight,
    measureElement: getMeasureElement(),
    overscan: 10,
    scrollMargin,
  })

  return <>{children(rowVirtualizer)}</>
}
